<script setup>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import StaffForm from './StaffForm.vue';
import StaffDataTable from '@/components/DataTable.vue';
import StaffStatistics from '@/components/StatisticData.vue';
// import iconLevel from '../../../public/icons/arrow-comparison.svg';
import iconUser from '../../../public/icons/users-alt.svg';
import { ref, defineModel } from 'vue';

const modal = defineModel()

</script>

<template>
    <HeaderContent title="Staff"/>
    <ActionContent ctaText="Add Staff" @action="modal = !modal "/>
    <StaffStatistics title="Staff Statistics" :data="statistics" />
    <StaffForm :modal="modal" @updateModal="modal = !modal"></StaffForm>
    <StaffDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

</template>


<script>
const data = [
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'Driver',
        phone_number : '08123456789',
        email : 'Adm_SA@example.com',
        address : 'Jl. Jalan 1',
        
    },
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'Supervisor',
        phone_number : '08123456789',
        email : 'adm_SPV@example.com',
        address : 'Jl. Jalan 2',
        
    },
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'Resepsionis',
        phone_number : '08123456789',
        email : 'adm_RS@example.com',
        address : 'Jl. Jalan 3',
        
    },
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'Back Office',
        phone_number : '08123456789',
        email : 'adm_BOf@example.com',
        address : 'Jl. Jalan 4',
        
    },
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'House Keeping',
        phone_number : '08123456789',
        email : 'adm_HK@example.com',
        address : 'Jl. Jalan 5',
        
    },
    {
        name : 'Mr. Adam',
        username : 'Staff1',
        position : 'Maintenance',
        phone_number : '08123456789',
        email : 'adm_MT@example.com',
        address : 'Jl. Jalan 6',
        
    },

    
    
]

const statistics = ref([
    // {
    //     label: 'Total',
    //     key: 'Level',
    //     value: 5,
    //     color: 'primary',
    //     icon: iconLevel,
    // },

    {
        label: 'Total',
        key: 'Staff',
        value: 8,
        color: 'primary',
        icon: iconUser,
    },
])
const headers = ref([
    {key : 'no',label: 'No'},
    {key : 'username', label : 'Username', class : 'text-left'},
    {key : 'position', label : 'Position',class : 'text-left'},
    {key : 'phone_number', label : 'Phone Number', class:'tex-left'},
    {key : 'email', label : 'Email', class:'text-left'},
    {key : 'address', label : 'Address',class:'text-left'},
    {key: 'action', label: 'Actions',}
])
const customActions = ref([
    {
        label: 'Non active data',
        variant: 'warning',
        icon: 'fas fa-user-slash',
        action: (item) => {

        console.log('Extra charge action clicked for:', item);
        // Implement your extra charge logic here
        }
    },
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        console.log('Edit action clicked for:', item);
        // Implement your edit logic here
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Delete action clicked for:', item);
        // Implement your delete logic here
        }
    },
    
]);
</script>